import $ from "jquery";

class BenefitsAccordion {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		const button = self.elem.querySelector('.js-accordion-btn');
		const content = self.elem.querySelector('js-accordion-content');

		if(!self.elem.classList.contains('active')) {
			// data tables need to be displayed when first intitalized
			// So show accordion content then after 200ms hide unless it has an 'active' class
			setTimeout(() => {
				self.elem.classList.add('deactive');
			}, 200);
		}

		button.addEventListener('click', evt => {
			evt.preventDefault();

			if(self.elem.classList.contains('active')) {
				self.elem.classList.remove('active');
				self.elem.classList.add('deactive');
			} else {
				self.elem.classList.add('active');
				self.elem.classList.remove('deactive');
			}

			// manually trigger window resize event incase accordion contains a datatable and the window has resized since it was first initialized.
			$(window).trigger('resize');
		});
	}
}

export default BenefitsAccordion;